import React, { useEffect, useState } from "react";
import ProjectLanguages from "../../components/projectLanguages/ProjectLanguages";
import "./GithubRepoCard.css";
import { Fade } from "react-reveal";

export default function GithubRepoCard({ repo, theme }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    // Function to handle key press
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setIsModalOpen(false); // Close modal when Escape is pressed
      }
    };

    // Add event listener when modal is open
    if (isModalOpen) {
      window.addEventListener("keydown", handleKeyDown);
    }

    // Cleanup: Remove event listener when modal closes
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isModalOpen]);

  return (
    <>
      <div
        className="repo-card-div"
        style={{ backgroundColor: theme.highlight }}
        onClick={() => setIsModalOpen(true)} // Open modal on click
      >
        <Fade bottom duration={2000} distance="40px">
          <div key={repo.id}>
            <div className="repo-name-div">
              <svg
                aria-hidden="true"
                className="octicon repo-svg"
                height="16"
                role="img"
                viewBox="0 0 12 16"
                width="12"
              >
                <path
                  fillRule="evenodd"
                  d="M4 9H3V8h1v1zm0-3H3v1h1V6zm0-2H3v1h1V4zm0-2H3v1h1V2zm8-1v12c0 .55-.45 1-1 1H6v2l-1.5-1.5L3 16v-2H1c-.55 0-1-.45-1-1V1c0-.55.45-1 1-1h10c.55 0 1 .45 1 1zm-1 10H1v2h2v-1h3v1h5v-2zm0-10H2v9h9V1z"
                ></path>
              </svg>
              <p className="repo-name" style={{ color: theme.text }}>
                {repo.name}
              </p>
            </div>
            <p className="repo-description" style={{ color: theme.text }}>
              {repo.description}
            </p>
          </div>
        </Fade>
      </div>

      {isModalOpen && (
        <div className="modal-overlay" onClick={() => setIsModalOpen(false)} >
          <div className={`modal-content ${isModalOpen ? "fadeIn" : "fadeOut"}`} onClick={(e) => e.stopPropagation()} style={{ backgroundColor: theme.body }}>
            <div className="modal-header">
              <h2>{repo.name}</h2>
              <button className="close-btn" onClick={() => setIsModalOpen(false)}>
                &times;
              </button>
            </div>
            <p><b>Description:</b> {repo.description}</p>
            <ProjectLanguages logos={repo.languages} />
            
            <p>
              <b>Link: {" "}</b>
              <a href={repo.url} target="_blank" rel="noopener noreferrer" className="repo-link">
                {repo.name}
              </a>
            </p>
          </div>
        </div>
      )}

    </>
  );
}
